<template>
    <div :style="{height:formDivHeight+'px',overflow: 'auto'}">
        <el-form :model="permissionForm" :rules="formRules" label-position="right" ref="permissionForm" label-width="100px" class="demo-ruleForm">
            <el-input  v-model="permissionForm.parentPermissionPid" type="hidden"></el-input>
            <el-form-item label="上级菜单" prop="perpermissionName">
                <el-input style="width: 98%" v-model="permissionForm.perpermissionName" readonly :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="菜单名称" prop="permissionName">
                <el-input v-model="permissionForm.permissionName" style="width: 98%" placeholder="输入菜单名称"></el-input>
            </el-form-item>
            <el-form-item label="菜单排序" prop="permissionIndex">
                <el-input type="number" v-model="permissionForm.permissionIndex" style="width: 98%" placeholder="输入菜单排序" ></el-input>
            </el-form-item>
            <el-form-item label="所属终端" prop="permissionType">
                <el-select v-model="permissionForm.permissionType"  style="width: 98%" placeholder="选择所属终端">
                    <el-option
                            v-for="item in typeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div style="text-align: center">
            <el-button type="primary" style="width: 100px" :disabled="saveButState" @click="submitForm()" v-html="saveButValue"></el-button>
            <el-button type="danger" style="width: 100px" @click="closeWindow()">关闭</el-button>
        </div>
    </div>
</template>
<script>
    import {appjs} from "@/utiljs/apputil";
    export default {
        props: {
            closeWindow: {
                type: Function
            },
            selectedPerData:{
                type: Object
            }
        },
        data() {
            return {
                formDivHeight: (document.documentElement.clientHeight-100),
                saveButValue: '保 存',
                saveButState: false,
                permissionForm: {
                    perpermissionName:'',
                    parentPermissionPid: '',
                    permissionMenu: '',
                    permissionName: '',
                    permissionType: '',
                    permissionIndex: ''
                },
                formRules: {
                    permissionName: [
                        { required: true, message: '请输入菜单名称', trigger: 'blur' }
                    ],
                    permissionIndex: [
                        { required: true, message: '请输入菜单排序', trigger: 'blur' }
                    ]

                },
                typeOptions:[
                    {value:'m',label:'移动端'},
                    {value:'p',label:'PC端'}
                ]
            }
        },
        created() {
            this.permissionForm.parentPermissionPid = this.selectedPerData.id;
            this.permissionForm.perpermissionName = this.selectedPerData.permissionname;
            this.permissionForm.permissionMenu = this.selectedPerData.permissionname;
        },
        methods:{
            resertForm() {
                this.saveButValue = '保 存';
                this.saveButState = false;
                this.formDivHeight = (document.documentElement.clientHeight-100);
                this.$refs['permissionForm'].resetFields();
                this.permissionForm.parentPermissionPid = this.selectedPerData.id;
                this.permissionForm.perpermissionName = this.selectedPerData.permissionname;
                this.permissionForm.permissionMenu = this.selectedPerData.permissionname;
            },
            submitForm() {
                this.$refs.permissionForm.validate((valid) => {
                    if (valid) {
                        let params = this.permissionForm;
                        this.saveButValue = '保存中....'
                        this.saveButState = true;
                        let _self = this;
                        appjs.httpRequest('permission/saveTwoPermission',params).then((data)=>{
                            if(data.retCode&&data.retCode!="ok"){
                                appjs.showErrorMsg(data.retMsg);
                                _self.saveButValue = '保存';
                                _self.saveButState = false;
                            }else{
                                _self.saveButValue = '保存成功';
                                _self.closeWindow(data.retMsg);
                            }
                        }).catch((error)=>{
                            _self.saveButState = false;
                            _self.loginText = '保存';
                            appjs.showErrorMsg("异常：" + error)
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        }
    }
</script>
